function EventStatsCtrl($state, $stateParams, $q, sdkEventService, sdkVenueService, sdkTicketStatService, mapperService, alertService, sdkUtils, managementUserService) {
  const vm = this;

  vm.loading = true;
  vm.venueId = $stateParams.venueId;

  const currentUser = managementUserService.getCurrentUser();

  vm.typeformURL = `https://tablelist-forms.typeform.com/to/HzsGGH?userid=${currentUser.id}&venueid=${$stateParams.venueId}`;

  $q.all([
      _getEventById($stateParams.eventId),
      _getTicketStats($stateParams.eventId)
    ])
    .then(results => {
      vm.event = results[0];
      vm.venue = results[0].venue;
      vm.ticketStats = results[1];

      if (!vm.event) {
        vm.noEvent = true;
        return;
      }

      vm.totalSold = 0;
      vm.total = 0;
      vm.totalRevenue = 0;
      vm.ticketProgress = 0;
      if (vm.ticketStats && vm.ticketStats.length) {
        vm.totalSold = vm.ticketStats[0].totalQuantitySold;
        vm.total = vm.ticketStats[0].totalQuantity;
        vm.totalRevenue = vm.ticketStats[0].totalRevenue;
        vm.ticketProgress = vm.totalSold / vm.total;
      }
    })
    .catch(response => {
      alertService.error(sdkUtils.getErrorFromResponse(response));
    })
    .finally(() => {
      vm.loading = false;
    });

  // ----------------------- private helpers ----------------------- //

  /**
   * @return {Promise}
   */
  function _getEventById(id) {
    if (!id) return $q.reject(new Error('id is required'));

    return sdkEventService.readById(id, {
        fields: [
          'name',
          'images',
          'primaryImage',
          'date',
          'venue(name)'
        ].join(',')
      })
      .then(mapperService.mapEventToUI);
  }

  /**
   * @return {Promise}
   */
  function _getTicketStats(eventId) {
    if (!eventId) return $q.reject(new Error('id is required'));

    return sdkTicketStatService.listByEventId(eventId);
  }
}

EventStatsCtrl.$inject = [
  '$state',
  '$stateParams',
  '$q',
  'jsSdk.event',
  'jsSdk.venue',
  'jsSdk.ticketStat',
  'mapperService',
  'alertService',
  'jsSdk.utils',
  'jsSdk.managementUser'
];

export default EventStatsCtrl;



// WEBPACK FOOTER //
// ./src/components/eventStats/eventStatsCtrl.js